import styles from './index.module.less';
import Image from 'next/image';
import dayjs from 'dayjs';
import React from 'react';
import { imgUrl } from '@/shared/utils';
import Link from 'next/link';
const Index: React.FC<{ data: any }> = ({ data }) => {
  return (
    <ul className={styles.container}>
      {data.map((item: any, index: number) => {
        return (
          <li key={item.id}>
            <Link href={item.url_path} prefetch={false} title={item.url_title}>
              <Image
                src={imgUrl(item.cover_image, 'mid')}
                alt={item.url_title}
                width={165}
                height={104}
                priority={index < 2 ? true : false}
                loading={index < 2 ? 'eager' : 'lazy'}
              />
              <div>
                <h2>{item.url_title}</h2>
                <div>{dayjs(item.insert_time).format('MMM DD, YYYY')}</div>
              </div>
            </Link>
          </li>
        );
      })}
    </ul>
  );
};

export default Index;
